import { Link } from "react-router-dom";


export const Users = () => {
    return (<>
        <Link to="/">Home</Link>
        <Link to="/users">Users</Link></>);
}